import { createContext, useContext, useEffect } from 'react';
import { fg } from '@atlassian/jira-feature-gating';

type Listeners = (jql: string) => void;

export class OnJQLChangePubSub {
	private listeners: Set<Listeners> = new Set();

	subscribe(listener: Listeners) {
		this.listeners.add(listener);
		return () => {
			this.listeners.delete(listener);
		};
	}

	publish(jql: string) {
		this.listeners.forEach((listener) => listener(jql));
	}
}

export const OnJQLChangeContext = createContext<OnJQLChangePubSub | null>(null);

export const useSubscribeToJQLChanges = (listener: Listeners) => {
	const pubSub = useContext(OnJQLChangeContext);

	useEffect(() => {
		if (!fg('list_lovability_improving_filters')) {
			return;
		}
		if (pubSub === null) {
			return;
		}

		return pubSub.subscribe(listener);
	}, [listener, pubSub]);
};
